import PropTypes from 'prop-types';
import React from 'react';

import IconUserCircle from '../Icons/IconUserCircle';

import './index.scss';

const Logout = ({ onClick, userProfile }) => {
  return (
    <>
      {userProfile && (
        <button
          type="button"
          onClick={onClick}
          className="logout-button"
          tabIndex="-1"
          data-testid="logout-button"
        >
          <span className="logout-button__text">Click to sign out</span>
          <IconUserCircle classNames="logout-button__icon" />
        </button>
      )}
    </>
  );
};

Logout.defaultProps = {
  userProfile: {},
};

Logout.propTypes = {
  onClick: PropTypes.func.isRequired,
  userProfile: PropTypes.shape({
    sub: PropTypes.string,
    email: PropTypes.string,
  }),
};
export default Logout;
